(function () {
  'use strict';

  var form = document.getElementById('NeogenPrelaunchSignup');
  if (!form) return;

  var input = form.querySelector('.signup__input');
  var submit = form.querySelector('.signup__submit');

  form.addEventListener('submit', function (event) {
    if (!input || !input.value || !input.checkValidity()) {
      event.preventDefault();
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        input.reportValidity();
      }
      return;
    }

    form.classList.add('is-submitting');
    form.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
  });

  if (input) {
    input.addEventListener('input', function () {
      if (input.checkValidity()) input.removeAttribute('aria-invalid');
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    form.classList.remove('is-submitting');
    form.removeAttribute('aria-busy');
    if (submit) submit.disabled = false;
  });
})();
